import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { SearchBox, Popover, Button } from 'next-common-lib';
import { searchAddressAPI } from '../../apis/contactAPI';
import './SearchAddress.scss';
import i18n from '../i18n/i18n';

// eslint-disable-next-line import/prefer-default-export
export const SearchAddress = ({ defaultValue, onSelect, onClose, top, left, isNoSession }) => {
  const [keyword, setKeyword] = useState(defaultValue);
  const [listContact, setListContact] = useState();

  const guideText = i18n.t('contacts.address.message.explain', { ns: 'contacts' }).split('<p class="expl">');
  const subGuideText = guideText[1].split('</p>');
  const [isShowFeedback, setIsShowFeedback] = useState(false);
  const [message, setMessage] = useState('');

  const handleSearch = e => {
    if (e && e.trim().length > 0) {
      (async () => {
        try {
          const data = await searchAddressAPI(e, 0, 100, isNoSession);
          if (data && data.elements && data.elements.length > 0) {
            setListContact(data.elements);
          } else {
            setListContact([]);
          }
        } catch (e) {
          console.log(e);
        }
      })();
    } else {
      setMessage(i18n.t('contacts.searchPeopleContactsTab.message.inputKeyword', { ns: 'contacts' }));
      setIsShowFeedback(true);
    }
  };

  const search = (
    <SearchBox
      showDeleteIcon={keyword && keyword.trim().length > 0}
      componentType="single"
      left="bottom-left"
      restrictedTypes="emoji"
      onChange={e => {
        setKeyword(e.target.value);
      }}
      value={keyword}
      onCloseLayer={() => console.log('after close')}
      onSearch={e => {
        handleSearch(e);
      }}
      placeholder={i18n.t('contacts.createContacts.text.roadBuilding', { ns: 'contacts' })}
      onDeleteText={() => setKeyword('')}
    />
  );

  const handleSelect = (zip, address) => {
    onSelect({
      zip,
      address,
    });
  };

  const table = (
    <>
      <div className="address-search-result">
        <div className="grid-table-wrap">
          <div className="grid-table-header">
            <div className="grid-table">
              <table>
                <colgroup>
                  <col style={{ width: '88px' }} />
                  <col style={{ width: 'auto' }} />
                </colgroup>
                <thead>
                  <tr className="multiple-lines">
                    <th className="align-center">
                      <div className="grid-data-cell">
                        <span className="text">
                          {i18n.t('contacts.createContacts.text.postal', { ns: 'contacts' })}
                        </span>
                        <i className="resize-dragger" />
                      </div>
                    </th>
                    <th className="align-center">
                      <div className="grid-data-cell">
                        <span className="text">
                          {i18n.t('contacts.createContacts.text.address', { ns: 'contacts' })}
                        </span>
                      </div>
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <div className="grid-table-body scroll-show">
            <div
              className="grid-table"
              id="addressSearchResult"
              style={{ height: '100%', width: '100%', maxWidth: 'inherit', maxHeight: 'inherit', overflowY: 'auto' }}
            >
              <table style={{ width: '100%' }}>
                <colgroup>
                  <col style={{ width: '88px' }} />
                  <col style={{ width: 'auto' }} />
                </colgroup>
                <tbody>
                  {listContact &&
                    listContact.length > 0 &&
                    listContact.map((item, index) => {
                      return (
                        <tr className="multiple-lines" key={index}>
                          <td className="align-center">
                            <div className="grid-data-cell">
                              <span className="text">{item.zip}</span>
                            </div>
                          </td>
                          <td>
                            <div className="grid-data-cell">
                              <ul className="address-result-item">
                                <li>
                                  <div className="pt-badge square bg-primary">
                                    <span className="text">
                                      {i18n.t('contacts.createContacts.text.roadName', { ns: 'contacts' })}
                                    </span>
                                  </div>
                                  <span
                                    className="address-text"
                                    onClick={() => {
                                      handleSelect(item.zip, item.roadAddr);
                                    }}
                                  >
                                    {item.roadAddr}
                                  </span>
                                </li>
                                <li>
                                  <div className="pt-badge square bg-darkgray">
                                    <span className="text">
                                      {i18n.t('contacts.createContacts.text.streetNumber', { ns: 'contacts' })}
                                    </span>
                                  </div>
                                  <span
                                    className="address-text"
                                    onClick={() => {
                                      handleSelect(item.zip, item.jibunAddr);
                                    }}
                                  >
                                    {item.jibunAddr}
                                  </span>
                                </li>
                                <li>
                                  <div className="pt-badge square bg-secondary">
                                    <span className="text">
                                      {i18n.t('contacts.address.text.english', { ns: 'contacts' })}
                                    </span>
                                  </div>
                                  <span
                                    className="address-text"
                                    onClick={() => {
                                      handleSelect(item.zip, item.enRoadAddr);
                                    }}
                                  >
                                    {item.enRoadAddr}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  {listContact && listContact.length === 0 && (
                    <tr>
                      <td colSpan="2" style={{ textAlign: 'center' }}>
                        <strong>{i18n.t('contacts.common.message.noSearch', { ns: 'contacts' })}</strong>
                        <br />
                        {i18n.t('contacts.common.message.noSearch2', { ns: 'contacts' })}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  const popupFeedback = (
    <Popover
      closeFunction={() => {
        setIsShowFeedback(false);
      }}
      bottomComponent={[
        <div className="btn-set al-right">
          <Button
            componentType="solid"
            className="primary"
            onClick={() => {
              setIsShowFeedback(false);
            }}
            label={i18n.t('contacts.searchPeopleContactsTab.text.ok', { ns: 'contacts' })}
          />
        </div>,
      ]}
      contentsComponent={[<p>{message}</p>]}
      size="xs"
      headerComponent={[<h1 className="popup-title">{i18n.t('contacts.common.text.notice', { ns: 'contacts' })}</h1>]}
    />
  );

  return (
    <>
      <Popover
        windowScrollInfo={{ scrollView: false, isAlwaysView: false }}
        className="popup-container popup--address popup--address--search popup-address"
        closeFunction={() => {
          onClose();
        }}
        contentsComponent={[
          <div className="guide-text">
            <p>{guideText[0]}</p>
            <p className="sub-text">{subGuideText[0]}</p>
          </div>,
          search,
          listContact && table,
        ]}
        headerComponent={[
          <h1 className="popup-title">{i18n.t('contacts.createContacts.button.searchPostal', { ns: 'contacts' })}</h1>,
        ]}
        size="sm"
        top={top}
        left={left}
      />
      {isShowFeedback && popupFeedback}
    </>
  );
};

SearchAddress.propTypes = {
  defaultValue: PropTypes.string,
  onSelect: PropTypes.func,
  onClose: PropTypes.func,
  top: PropTypes.string,
  left: PropTypes.string,
  isNoSession: PropTypes.bool,
};

SearchAddress.defaultProps = {
  defaultValue: '',
  onSelect: () => {},
  onClose: () => {},
  top: '',
  left: '',
  isNoSession: false,
};
